import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const createRouter = () => new Router({
  base: process.env.BASE_URL,
  routes:[
    {path:'/',redirect:'table'},
    {path:'/login',name:'login',component:()=>import('./views/login/login')},
    {path:'/lock',name:'lock',component:()=>import('./views/login/lock')},
    {path:'/clock',name:'clock',component:()=>import('./views/login/clock')},
    {path:'/index',redirect:'/table',component:()=>import('./views/index/index'),children:[
      {path:'/table',name:'table',meta:{isRequireLogin:true},component:()=>import('./views/subs/table/index.vue')},
      {path:'/menu',name:'menu',meta:{isRequireLogin:true},component:()=>import('./views/subs/menu/index.vue')},
      {path:'/lineup',name:'lineup',meta:{isRequireLogin:true},component:()=>import('./views/subs/lineup/index.vue')},
      {path:'/items',name:'items',meta:{isRequireLogin:true},component:()=>import('./views/subs/items/index.vue')},
      {path:'/shop',name:'shop',meta:{isRequireLogin:true},component:()=>import('./views/subs/shop/index.vue')},
      {path:'/qrcode',name:'qrcode',meta:{isRequireLogin:true},component:()=>import('./views/subs/qrcode/index.vue')},
      {path:'/orderNew',name:'orderNew',meta:{isRequireLogin:true},component:()=>import('./views/subs/orderNew/index.vue')},

      {path:'/order',name:'order',meta:{isRequireLogin:true},component:()=>import('./views/subs/order/index.vue')},
      {path:'/orderDetail',name:'orderDetail',meta:{isRequireLogin:true},component:()=>import('./views/subs/order/orderDetail')},

      {path:'/feedback',name:'feedback',meta:{isRequireLogin:true},component:()=>import('./views/subs/feedback/index.vue')},
      {path:'/feedbackDetail',name:'feedbackDetail',meta:{isRequireLogin:true},component:()=>import('./views/subs/feedback/feedbackDetail.vue')},
      
      {path:'/calcway',name:'calcway',meta:{isRequireLogin:true},component:()=>import('./views/subs/menu/calcway.vue')},
      {path:'/calcwayFood',name:'calcwayFood',meta:{isRequireLogin:true},component:()=>import('./views/subs/menu/calcwayFood.vue')},
      {path:'/calcwayAvg',name:'calcwayAvg',meta:{isRequireLogin:true},component:()=>import('./views/subs/menu/calcwayAvg.vue')},
      {path:'/calcwayCus',name:'calcwayCus',meta:{isRequireLogin:true},component:()=>import('./views/subs/menu/calcwayCus.vue')},

      {path:'/book',name:'book',meta:{isRequireLogin:true},component:()=>import('./views/subs/book/index.vue')},
      {path:'/timeSetting',name:'timeSetting',meta:{isRequireLogin:true},component:()=>import('./views/subs/book/timeSetting.vue')},
      {path:'/createBook',name:'createBook',meta:{isRequireLogin:true},component:()=>import('./views/subs/book/createBook.vue')},
    ]},
  ]
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}

export default router